/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];
    
    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Personal Information View Model      
    // Holds the Person Data
    /**************************************/
    function PersonalInformationViewModel(data) {

        // Self-Identification
        var self = this;

        /***  PROPERTIES ***/
        // [EXTEND] Add any properties here that are captured from the view
        this.ID = ko.validatedObservable();
        this.FirstName = ko.validatedObservable();
        this.MiddleName = ko.validatedObservable();
        this.LastName = ko.validatedObservable();
        this.PreferredName = ko.validatedObservable();
        this.DateOfBirth = ko.validatedObservable();
        this.GenderID = ko.validatedObservable();
        this.TaxID = ko.validatedObservable();
        this.SIN = ko.validatedObservable();
        this.IdentifierID = ko.validatedObservable();
        this.IdentifierGID = ko.validatedObservable();
        this.ASN = ko.validatedObservable();
        this.SalutationID = ko.validatedObservable();
        this.PrimaryEmailAddressGID = ko.observable();
        this.PrimaryEmailAddressID = ko.observable();
        this.PrimaryEmailAddress = ko.validatedObservable();
        this.GetTaxIdRegex = data && data.getTaxIdRegex;
        this.ConfirmEmail = ko.validatedObservable();
        this.PersonalConfirmEmailTemplate = ko.observable('');
        this.SetBirthDateRequired = ko.observable(false);
        this.HideTaxId = ko.observable(false);
        this.HideSIN = ko.observable(false);
        this.HideASN = ko.observable(false);
        this.SummaryPersonTemplate = ko.observable('');
        this.PersonalSectionUpdate = ko.observable('');
        this.FirstNameUpdated = ko.observable('');
        this.PreferredNameUpdated = ko.observable('');
        this.PersonalSectionPreferredName = ko.observable('');
        this.PersonalSectionMiddleName = ko.observable('');
        this.PersonalSectionLastName = ko.observable('');
        this.PersonalSectionFullName = ko.observable('');
        this.PersonalSectionDOB = ko.observable('');
        this.HideCoreFieldsPersonalSection = ko.observable(false);
        this.IsDOBRequired = ko.observable(false);
        this.IsMiddleNameRequired = ko.observable(false);
        this.IsGenderRequired = ko.observable(false);
        this.IsSINRequired = ko.observable(false);
        this.IsCustomisedUK = ko.observable(false);
        this.ProvincialNumbers = ko.observableArray();
        this.IsDuplicateProvincialBMN = ko.observable(false);
        this.ProvincialBMN = ko.observable();
        this.SelectedProvincialNumbers = ko.observableArray();

        /* code for handling masked sin start */
        this.displayValidationError = ko.observable(false);
        this.keyType = ko.observable(null);
        this.keyVal = ko.observable(null);
        this.selectionStart = ko.observable(0);
        this.selectionEnd = ko.observable(null);
        this.isMouseClicked = ko.observable(false);
        this.isShiftKeyPressedFirstTime = ko.observable(true);
        this.isShiftKeyPressed = ko.observable(false);
        this.setValidationError = function() {
            self.displayValidationError(true);
        }
        
        this.formattedTaxID = ko.computed({
                read: function () {
                    if(this.SIN()) {
                        function MaskCharacter(str, mask, n = 1) {
        
                            // Slice the string and replace with
                            // mask then add remaining string
                            return ('' + str).slice(0, -n)
                                .replace(/./g, mask)
                                + ('' + str).slice(-n);
                        }
                        return MaskCharacter(this.SIN().toString(),"X", 3)
                    }
                },
                write: function (value) {
                    function setSelectionRange(input, selectionStart, selectionEnd) {
                        var input = document.getElementById(input)
                        if (input.setSelectionRange) {
                            input.focus();
                            input.setSelectionRange(selectionStart, selectionEnd);
                        }
                        else if (input.createTextRange) {
                            var range = input.createTextRange();
                            range.collapse(true);
                            range.moveEnd('character', selectionEnd);
                            range.moveStart('character', selectionStart);
                            range.select();
                        }
                    }

                    function setCaretPosition (input, pos) {
                        setSelectionRange(input, pos, pos);
                    }

                    if(this.keyType() == 'backSpace') {
                        if(self.isShiftKeyPressed()) {
                            if(self.selectionEnd() == 0) {
                                this.SIN(this.SIN().toString().slice(self.selectionStart()))
                                self.selectionStart(0);
                                self.selectionEnd(0)
                            } else if(self.selectionEnd() == this.SIN().toString().length) {
                                this.SIN(this.SIN().substring(0, this.selectionStart()))
                                self.selectionStart(this.SIN().toString().length);
                                self.selectionEnd(this.SIN().toString().length);
                            } else if(this.selectionStart() > this.selectionEnd()) {
                                var a = this.SIN().substring(0, this.selectionEnd());
                                var b = this.SIN().substring(this.selectionStart());
                                self.selectionStart(this.selectionEnd());
                                self.selectionEnd(this.selectionEnd());
                                self.SIN(a+b);
                            } else if(this.selectionStart() < this.selectionEnd()) {
                                var a = this.SIN().substring(0, this.selectionStart());
                                var b = this.SIN().substring(this.selectionEnd());
                                self.selectionStart(this.selectionEnd());
                                self.selectionEnd(this.selectionEnd());
                                self.SIN(a+b);
                            } else if(Math.abs(self.selectionStart() - self.selectionEnd()) == 9) {
                                self.SIN("");
                            }
                            setCaretPosition("PersonSIN", self.selectionEnd())
                            self.isShiftKeyPressed(false);
                            self.isShiftKeyPressedFirstTime(true);

                        } else if(self.isMouseClicked() == false) {
                            if(self.selectionStart() == 0) {
                                self.SIN(self.SIN().substring(1));
                                setCaretPosition("PersonSIN", 0);
                            } else {
                                let a = this.SIN().slice(0, self.selectionStart() - 1);
                                let b = this.SIN().slice(self.selectionStart());
                                self.SIN(a+b);
                                self.selectionStart(self.selectionStart() - 1)
                                setCaretPosition("PersonSIN", self.selectionStart())
                            }
                        } else {
                            if(self.selectionEnd() == 0) {
                                this.SIN(this.SIN().toString().slice(self.selectionStart()))
                                self.selectionStart(0);
                                self.selectionEnd(0)
                            } else if(self.selectionEnd() == this.SIN().toString().length) {
                                this.SIN(this.SIN().substring(0, this.selectionStart()))
                                self.selectionStart(this.SIN().toString().length);
                                self.selectionEnd(this.SIN().toString().length);
                            } else if(this.selectionStart() > this.selectionEnd()) {
                                var a = this.SIN().substring(0, this.selectionEnd());
                                var b = this.SIN().substring(this.selectionStart());
                                self.selectionStart(this.selectionStart());
                                self.selectionEnd(this.selectionStart());
                                self.SIN(a+b);
                            } else if(this.selectionStart() < this.selectionEnd()) {
                                var a = this.SIN().substring(0, this.selectionStart());
                                var b = this.SIN().substring(this.selectionEnd());
                                self.selectionStart(this.selectionStart());
                                self.selectionEnd(this.selectionStart());
                                self.SIN(a+b);
                            } else if(Math.abs(self.selectionStart() - self.selectionEnd()) == 9) {
                                self.SIN("");
                            }
                            setCaretPosition("PersonSIN", self.selectionEnd())
                            self.isMouseClicked(false);
                        }
                        
                    } 
                    if(this.keyType() == 'numeric') {
                        if(this.SIN() == null) {
                            this.SIN("");
                        }
                        if(this.SIN().toString().length < 9) {
                            if(self.selectionStart() == 0) {
                                self.SIN(this.keyVal().toString() + self.SIN());
                                this.selectionStart(this.selectionStart() + 1);
                                this.selectionEnd(this.selectionStart());
                                setCaretPosition("PersonSIN", self.selectionStart())
                            } else {
                                let a = this.SIN().slice(0, self.selectionStart());
                                let b = this.SIN().slice(self.selectionStart());
                                self.SIN(a + this.keyVal() + b);
                                this.selectionStart(this.selectionStart() + 1);
                                this.selectionEnd(this.selectionStart());
                                setCaretPosition("PersonSIN", self.selectionStart())
                            }
                        }
                    }
                    if(this.keyType() == 'delete') {
                        if(self.isShiftKeyPressed() == true) {
                            if(self.selectionEnd() == 0) {
                                this.SIN(this.SIN().toString().slice(self.selectionStart()))
                                self.selectionStart(0);
                                self.selectionEnd(0)
                            } else if(self.selectionEnd() == this.SIN().toString().length) {
                                this.SIN(this.SIN().substring(0, this.selectionStart()))
                                self.selectionStart(this.SIN().toString().length);
                                self.selectionEnd(this.SIN().toString().length);
                            } else if(this.selectionStart() > this.selectionEnd()) {
                                var a = this.SIN().substring(0, this.selectionEnd());
                                var b = this.SIN().substring(this.selectionStart());
                                self.selectionStart(this.selectionEnd());
                                self.selectionEnd(this.selectionEnd());
                                self.SIN(a+b);
                            } else if(this.selectionStart() < this.selectionEnd()) {
                                var a = this.SIN().substring(0, this.selectionStart());
                                var b = this.SIN().substring(this.selectionEnd());
                                self.selectionStart(this.selectionStart());
                                self.selectionEnd(this.selectionStart());
                                self.SIN(a+b);
                            } else if(Math.abs(self.selectionStart() - self.selectionEnd()) == 9) {
                                self.SIN("");
                            }
                            self.isShiftKeyPressed(false);
                            
                            setCaretPosition("PersonSIN", self.selectionEnd())

                            
                        } else if(self.isMouseClicked() == false) {
                            let a = this.SIN().slice(0, self.selectionStart());
                            let b = this.SIN().slice(self.selectionStart() + 1);
                            self.SIN(a+b);
                            setCaretPosition("PersonSIN", self.selectionStart())
                        } else {
                            if(self.selectionEnd() == 0) {
                                this.SIN(this.SIN().toString().slice(self.selectionStart()))
                                self.selectionStart(0);
                                self.selectionEnd(0)
                            } else if(self.selectionEnd() == this.SIN().toString().length) {
                                this.SIN(this.SIN().substring(0, this.selectionStart()))
                                self.selectionStart(this.SIN().toString().length);
                                self.selectionEnd(this.SIN().toString().length);
                            } else if(this.selectionStart() > this.selectionEnd()) {
                                var a = this.SIN().substring(0, this.selectionEnd());
                                var b = this.SIN().substring(this.selectionStart());
                                self.selectionStart(this.selectionStart());
                                self.selectionEnd(this.selectionStart());
                                self.SIN(a+b);
                            } else if(this.selectionStart() < this.selectionEnd()) {
                                var a = this.SIN().substring(0, this.selectionStart());
                                var b = this.SIN().substring(this.selectionEnd());
                                self.selectionStart(this.selectionStart());
                                self.selectionEnd(this.selectionStart());
                                self.SIN(a+b);
                            } else if(Math.abs(self.selectionStart() - self.selectionEnd()) == 9) {
                                self.SIN("");
                            }
                            setCaretPosition("PersonSIN", self.selectionEnd())
                            self.isMouseClicked(false);
                        }
                    } 
                    if(this.keyType() == 'arrowLeft') {
                        self.isShiftKeyPressed(false);
                        self.isShiftKeyPressedFirstTime(false);
                        var input = document.getElementById('PersonSIN');
                        if(self.selectionStart() > 0) {
                            self.selectionStart(self.selectionStart() - 1)
                            self.selectionEnd(self.selectionStart())
                            setCaretPosition("PersonSIN", self.selectionStart())
                        }
                    } 
                    if(this.keyType() == 'arrowRight') {
                        self.isShiftKeyPressed(false);
                        self.isShiftKeyPressedFirstTime(false);
                        if(self.selectionStart() < self.SIN().length) {
                            self.selectionStart(self.selectionStart() + 1)
                            self.selectionEnd(self.selectionStart())
                            setCaretPosition("PersonSIN", self.selectionStart())
                        }    
                    } 
                    if(this.keyType() == 'shiftPlusLeft') {
                        var input = document.getElementById('PersonSIN');
                        input.setSelectionRange(self.selectionEnd(), self.selectionStart());
                    } 
                    if(this.keyType() == 'shiftPlusRight') {
                        var input = document.getElementById('PersonSIN');
                        input.setSelectionRange(self.selectionStart(), self.selectionEnd());
                    } 
                },
                owner: this
            });
           
            this.changetaxid = function(data, e) {
                
                if(e.shiftKey) {
                    if(e.keyCode == 37) {
                        self.isShiftKeyPressed(true)
                        self.keyType('shiftPlusLeft');
                        var input = document.getElementById('PersonSIN');
                        if(self.isShiftKeyPressedFirstTime()) {
                            self.selectionStart(input.selectionStart);  
                            self.selectionEnd(input.selectionStart - 1); 
                            self.isShiftKeyPressedFirstTime(false);
                        } else {
                            if(self.selectionEnd() > 0) 
                            self.selectionEnd(self.selectionEnd() - 1)
                        }
                    } 

                    if(e.keyCode == 39) {
                        self.isShiftKeyPressed(true)
                        self.keyType('shiftPlusRight');
                        var input = document.getElementById('PersonSIN');
                        if(self.isShiftKeyPressedFirstTime()) {
                            self.selectionStart(input.selectionStart);  
                            self.selectionEnd(input.selectionStart + 1); 
                            self.isShiftKeyPressedFirstTime(false);
                        } else {
                            if(self.selectionEnd() <= self.SIN().toString().length)
                            self.selectionEnd(self.selectionEnd() + 1)
                        }
                    } 
                } else if(e.keyCode == 8) {
                    self.keyType('backSpace')
                } else if((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) {
                    self.keyType('numeric')
                    self.keyVal(e.key);
                } else if(e.keyCode == 46) {
                    self.keyType('delete')
                } else if(e.keyCode == 37) {
                    self.keyType('arrowLeft')
                } else if(e.keyCode == 39) {
                    self.keyType('arrowRight')
                } else {
                    return;
                }
            };

            this.selectedText = function(data, e) {
                if(self.isShiftKeyPressed() == false) {
                    var input = document.getElementById('PersonSIN');
                        self.selectionStart(input.selectionStart);
                        self.selectionEnd(input.selectionEnd)
                        self.keyType('mouseClick');
                        if(self.selectionStart() != self.selectionEnd()) {
                            self.isMouseClicked(true);
                        } 
                }
            }

            this.handleMouseSelection = function(data, e) {
                if(e.button == 0) {
                    var input = document.getElementById('PersonSIN');
                    self.selectionStart(input.selectionStart);
                    self.selectionEnd(input.selectionEnd)
                    self.keyType('mouseClick');
                    if(self.selectionStart() != self.selectionEnd()) {
                        self.isMouseClicked(true);
                    }
                }
                var input = document.getElementById('PersonSIN');
                    self.selectionStart(input.selectionStart);
                    self.selectionEnd(input.selectionEnd)
                
            }       
        /* code for handling masked sin end */
        
        
        /***  PROPERTIES ***/

        /***  LIST DATA PROPERTIES ***/
        this.Salutations = ko.observableArray([]);
        this.Genders = ko.observableArray([]);
        /***  LIST DATA PROPERTIES ***/

        /*** SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable("BasicPersonContainer");
        this.Touched = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);
        /*** SECTION PROPERTIES ***/

        sm.portal.vm.custom.setCustomLocalizeKey(self);

        /***  COMPUTED PROPERTIES ***/
        this.FullName = ko.computed(function () {
            var name = '';
            if (!sm.portal.utility.isNullOrEmpty(this.FirstName())) {
                name += this.FirstName();
            }
            if (!sm.portal.utility.isNullOrEmpty(this.MiddleName())) {
                name += ' ' + this.MiddleName();
            }
            if (!sm.portal.utility.isNullOrEmpty(this.LastName())) {
                name += ' ' + this.LastName();
            }
            return name;
        }, this);
        this.AnythingPopulated = ko.computed(function () {
            return true;    // required section
        }, this);
        /***  COMPUTED PROPERTIES ***/

        /*** SECTION METHODS ***/
        this.SchemaDict = {};
        this.SchemaFields = function (container) {
            if (container !== undefined && container.Payload.Schema != null && container.Payload.Schema.Fields != null) {
                for (var i = 0; i < container.Payload.Schema.Fields.length; i++) {
                    var field = container.Payload.Schema.Fields[i];

                    if (field != null && field.FieldName != null) {
                        //hardcode this so only TaxID is added in the future need to add more
                        var key = "TaxID";
                        if (field.FieldName == key) {
                            this.SchemaDict[key] = field;

                        }
                    }
                }

            }
        };

        this.UpdateSelectedProvincialNumbers = function(provincialBMN){
            self.HandleProvincialBMNChange(provincialBMN);
            self.ProvincialNumbers().forEach(function(provincialNumber){
                if(!self.IsDuplicateProvincialBMN() && provincialNumber.BusinessMeaningName == provincialBMN){
                    self.SelectedProvincialNumbers.push(new SelectedProvincialNumber(provincialNumber));
                    self.ProvincialBMN(null);
                }
            })
        }

        this.HandleProvincialBMNChange = function(provincialBMN){
            var enteredProvincialBMN = ko.observable(provincialBMN); 
            self.IsDuplicateProvincialBMN(false);               
            self.SelectedProvincialNumbers().forEach(function(provincialNumber){
                if(provincialNumber.BusinessMeaningName() == enteredProvincialBMN()){
                    self.IsDuplicateProvincialBMN(true);
                }
            })
        }

        this.DeleteProvincialNumber = function(provincialBMN){;
            self.SelectedProvincialNumbers.remove(function(provincialNumber){
                return provincialNumber.BusinessMeaningName() == provincialBMN();
            });
            self.HandleProvincialBMNChange(provincialBMN());
        }

        this.LoadModel = function (container) {
            // update application section configurations
            if (container && container.Payload && container.Payload.Config) {
                viewModel.SetSectionsConfigData("BasicPerson", container.Payload.Config);
            }

            // Standard List Data
            self.Salutations = smapi.access.loadListItemModels(container.Payload.ListData.Salutation, self.Salutations);
            self.Genders = smapi.access.loadListItemModels(container.Payload.ListData.Gender, self.Genders);
            self.ProvincialNumbers(container.Payload.ProvincialTerritorialStudentNumbersFull);
            if(container && container.Payload && container.Payload.ProvincialTerritorialStudentNumbers){
                for(var i = 0; i < container.Payload.ProvincialTerritorialStudentNumbers.length; i++){
                    self.SelectedProvincialNumbers.push(new SelectedProvincialNumber(container.Payload.ProvincialTerritorialStudentNumbers[i]));
                }
            }
            self.SchemaFields(container);

            if (container.Payload.BasicPerson != null) {

                self.ID(container.Payload.BasicPerson.ID);
                self.SalutationID(container.Payload.BasicPerson.SalutationID);
                self.FirstName(container.Payload.BasicPerson.FirstName);
                self.MiddleName(container.Payload.BasicPerson.MiddleName);
                self.LastName(container.Payload.BasicPerson.LastName);
                self.PreferredName(container.Payload.BasicPerson.PreferredName);
                
                var loadPersonData = {
                    container: container,
                    self: self,
                    viewModel: viewModel
                }        
                sm.portal.vm.custom.callCustomization('LoadPersonInformationData', loadPersonData,
                    function () {
                        if (container.Payload.BasicPerson.DateOfBirth != null && container.Payload.BasicPerson.DateOfBirth != undefined) {
                            var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
        
                            self.DateOfBirth(moment(new Date(container.Payload.BasicPerson.DateOfBirth)).format(dateFormat));
                        } else {
                            self.DateOfBirth(container.Payload.BasicPerson.DateOfBirth);
                        } self.GenderID(container.Payload.BasicPerson.GenderID);
        
                        self.TaxID(container.Payload.BasicPerson.TaxID);
                        self.SIN(container.Payload.BasicPerson.SIN);
                        
        
                        if (typeof sm.portal.vm.apaspersoninformation !== 'undefined' && sm.portal.utility.isAPASFeatureEnabled()) {
                            self = sm.portal.vm.apaspersoninformation.LoadModel(self, container);
                        }
        
                        self.PrimaryEmailAddressID(container.Payload.BasicPerson.Email.PrimaryEmailID);
                        self.PrimaryEmailAddressGID(container.Payload.BasicPerson.Email.PrimaryEmailGID);
                        self.PrimaryEmailAddress(container.Payload.BasicPerson.Email.PrimaryEmail);
        
                        // Pull the Application ID into the View Model (since it doesn't have it's own GetData routing.
                        viewModel.ApplicationID(container.Payload.FullAttempt.ID);
                    }
                );
            }

            //loop through the schema dictionary
            for (key in this.SchemaDict) {
                var keyStr = key;
                for (prop in self) {
                    if (prop === keyStr) {

                        var schemaDef = self.SchemaDict[prop];

                        jQuery.validator.addMethod("ssnInput", function (value, element) {
                            var re = new RegExp(schemaDef.ValidationExpression);
                            return this.optional(element) || re.test(value);
                        }, schemaDef.InvalidMessage);

                    }
                }

            }

            //can we push this to our validation

            self.DataLoading(false);
            self.DataLoaded(true);
            if (smapi.constant.applicationDebugFlag) { console.log('[PersonalVM] Data Loaded'); }
        };

        this.GetModelData = function (blockui, applicationMID, personMID, callback) {
            
            if (!self.DataLoaded() && !self.DataLoading()) {

                self.DataLoading(true);
                if(!sm.portal.utility.isNullOrEmpty(viewModel.allCustomData())) {
                    self.LoadModel(viewModel.allCustomData().BasicPerson);
                    self.IsDOBRequired(viewModel.allCustomData().BasicPerson.Payload.Config.BirthDate);
                    self.IsGenderRequired(viewModel.allCustomData().BasicPerson.Payload.Config.Gender);
                    self.IsMiddleNameRequired(viewModel.allCustomData().BasicPerson.Payload.Config.MiddleName);
                    if(!(sm.portal.utility.isCanadaFeatureEnabled() || sm.portal.utility.isAPASFeatureEnabled())) {
                        self.IsSINRequired(viewModel.allCustomData().BasicPerson.Payload.Config.SocialSecurityNumber);
                    }
                    var customData = {
                        data: viewModel.allCustomData().BasicPerson,
                        self: self
                    }
                    sm.portal.vm.custom.callCustomization('LoadPersonInformation', customData,
                        function () {
                            callback && callback(viewModel.allCustomData().BasicPerson);      
                        }
                    );
                    return;
                }
                if (blockui) { self.BlockContainer() }
                var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName=person&attemptmid={0}', applicationMID);

                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        sm.portal.page.application.modelDataResponseHandler(self, data, applicationMID, personMID);
                        self.IsDOBRequired(data.Payload.Config.BirthDate);
                        self.IsGenderRequired(data.Payload.Config.Gender);
                        self.IsMiddleNameRequired(data.Payload.Config.MiddleName);
                        if(!(sm.portal.utility.isCanadaFeatureEnabled() || sm.portal.utility.isAPASFeatureEnabled())) {
                            self.IsSINRequired(data.Payload.Config.SocialSecurityNumber);
                        }
                        var customData = {
                            data: data,
                            self: self
                        }
                        sm.portal.vm.custom.callCustomization('LoadPersonInformation', customData,
                            function () {
                                callback && callback(data);      
                            }
                        );
                    },
                    error: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        callback && callback();
                    }
                });
            } else {
                callback && callback();
            }
        };

        this.InitializeOnUserCreated = function (container) {

            // Set the appropriate variables
            this.PrimaryEmailAddressID(container.PrimaryEmailID);
            this.PrimaryEmailAddressGID(container.PrimaryEmailGID);
        };
        this.BlockContainer = function () {
            jQuery("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function () {
            jQuery("#" + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };
        this.ProcessOnServer = function () {
            return true;
        };
        

        this.ExtractATO = function () {
            var stdEmail = new smapi.community.ElectronicAddressModel({
                ContactID: 0,
                Value: self.PrimaryEmailAddress(),
                EffectiveFromJS: null,
                EffectiveToJS: null,
                DoNotContact: false,
                NoContactReasonID: 0,
                AddressTimingTypeID: 0,
                ID: self.PrimaryEmailAddressID(),
                GID: self.PrimaryEmailAddressGID()
            });

            var personATO = sm.portal.vm.custom.callCustomization('ExtractPersonalATO', self);

            if (personATO) {
                return {
                    Person: personATO
                };
            }

            // [EXTEND] New fields added to view model need to be updated here and should match the Client Toolkit Model definition
            var personModel = new smapi.community.PersonModel({
                Surname: self.LastName(),
                GivenName: self.FirstName(),
                MiddleName: self.MiddleName(),
                TaxID: sm.portal.utility.isNullOrEmpty(self.TaxID()) ? null : self.TaxID(),
                SIN: self.SIN(),
                GenderID: self.GenderID(),
                DateOfBirth: self.DateOfBirth(),
                ID: self.ID(),
                PreferredGivenName: self.PreferredName(),
                Email: stdEmail,
                IDs: self.SelectedProvincialNumbers()
            });

            var atoModel = {
                Person: personModel,
                Email: stdEmail
            };

            if (typeof sm.portal.vm.apaspersoninformation !== 'undefined' && sm.portal.utility.isAPASFeatureEnabled()) {
                atoModel.PersonModel = sm.portal.vm.apaspersoninformation.ExtractATO(self);
            }
            if (typeof sm.portal.vm.eupersoninformation !== 'undefined' && sm.portal.utility.isEUFeatureEnabled()) {
                atoModel.PersonModel = sm.portal.vm.eupersoninformation.ExtractATO(self);
            }
            if (typeof sm.portal.vm.ukpersoninformation !== 'undefined' && sm.portal.utility.isUKFeatureEnabled()) {
                atoModel.PersonModel = sm.portal.vm.ukpersoninformation.ExtractATO(self);
            }
            return atoModel;
        };
        /*** SECTION METHODS ***/
        sm.portal.vm.custom.callCustomization('SetPersonProperties', self);
        sm.portal.vm.custom.callCustomization('OverridePersonInfoValidation', self);

        /*** VALIDATION METHODS ***/
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FirstName.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.MiddleName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.IsMiddleNameRequired();
                }
            },
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.LastName.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.PreferredName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.DateOfBirth.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.IsDOBRequired();
                }
            },
            smLocalDate: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            },
            smDateOfBirth: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.Validate_MustBeProperDateOfBirth_Key)
            }
        });
        this.SalutationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GenderID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    if(sm.portal.utility.isUKFeatureEnabled()){
                        return false;
                    }else return self.IsGenderRequired();
                }
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PrimaryEmailAddress.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            email: {
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'Example@domain.com')
            },
            maxLength: {
                params: 250,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
            },
            validation: {
                validator: function (val) {
                    if(!sm.portal.utility.isNullOrEmpty(val)) {
                        var url = _baseApiUri + 'api/studentportal/DuplicatedEmail?email=' + val;

                        var duplicatedEmail;

                        var successCallback = function (data) {
                            duplicatedEmail = data;
                        };

                        var options = {
                            async: false
                        };

                        sm.portal.utility.AjaxGet(url, successCallback, null, null, options);
                        if (duplicatedEmail)
                            return false;

                        return true;
                    }
                    return true;
                },
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_DuplicateEmail_Key)
            }
        });
        this.ProvincialBMN.extend({
            validation: {
                validator:function(val){
                    return !self.IsDuplicateProvincialBMN();
                },
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_DuplicateProvincialBMNEntry_Key),
                onlyIf: function () {
                    return self.IsDuplicateProvincialBMN();
                }
            }
        });

        // Get regex validation for TaxId and SIN
        this.GetTaxIdValidationRegex = function () {
            if (this.GetTaxIdRegex) {
                sm.portal.utility.getNationalIdentificationRegex(function (taxIdValidationRegex) {
                    self.GetTaxIdRegex = false;
                    var validation = sm.portal.utility.getNationalIdentificationValidation();
                  
                    if(sm.portal.utility.isCanadaFeatureEnabled() || sm.portal.utility.isAPASFeatureEnabled()) {
                        self.formattedTaxID.extend({
                            required: {
                                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                                onlyIf: function () {
                                    return self.IsSINRequired();
                                }
                            },
                            validation:{
                                validator: function(){ 
                                    if(self.displayValidationError()) {
                                        self.displayValidationError(false);
                                        return sm.portal.utility.ValidateCanadaSIN(self.SIN())
                                    } else {
                                        return true;
                                    }
                                },
                                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), '#########'),
                                params: self.SIN
                            },
                        });
                    } else {
                        self.TaxID.extend({
                            required: {
                                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                                onlyIf: function () {
                                    if(self.IsCustomisedUK()){
                                        return false
                                    }else return self.IsSINRequired();
                                }
                            },
                            pattern: {
                                params: taxIdValidationRegex,
                                message: validation.patternMessage
                            },
                            maxLength: {
                                params: validation.maxLengthParams,
                                message: validation.maxLengthMessage
                            }
                        });
                    }
                });
            }
        };
        
        this.IdentifierID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        if (typeof sm.portal.vm.apaspersoninformation !== 'undefined' && sm.portal.utility.isAPASFeatureEnabled()) {
            this.ASN.extend({
                required: {
                    params: true,
                    message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
                },
                pattern: {
                    params: "^[0-9]{9}$",
                    message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), '#########')
                },
                maxLength: {
                    params: 9,
                    message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), '#########')
                }
            });
        }

        this.IsSelectedProvincialNumberVMValid = ko.computed(function(){
            var isValid = true;
            self.SelectedProvincialNumbers().forEach(function(provincialNumber){
                if(!provincialNumber.IsVMValid()){
                    isValid = false;
                }
            })
            return isValid;
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                if(sm.portal.utility.isAPASFeatureEnabled()){
                    return this.IsSelectedProvincialNumberVMValid();
                }
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {

            var isCompleted = this.IsVMValid();
            return isCompleted;

        }, this);

        //  Get regex validation for TaxId and SIN
        if(sm.portal.utility.isNullOrEmpty(sm.portal.vm.custom.callCustomization('IsRequiredApi'))) {
            this.GetTaxIdValidationRegex();
        }
        /*** VALIDATION METHODS ***/

        return self;
    };

    function SelectedProvincialNumber(options){
        var self = this;
        self.Identifier = ko.observable(options.AgencyAssignedID);
        self.AgencyName = ko.observable(options.AgencyName || options.Name);
        self.BusinessMeaningName = ko.observable(options.BusinessMeaningName);
        self.GID = ko.observable(options.GID);
        self.ID = ko.observable(options.ID || 0);
        self.Name = ko.observable(options.AgencyName || options.Name);

        this.Identifier.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
            },
            pattern: {
                params: /^[A-Za-z0-9]+$/g,
                message: sm.resources.portalResource.getValue('Validate_Alphanumeric')
            },
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });

        this.Identifier.isModified(true);

        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
    }

    jQuery.extend(true, sm.portal.vm, {
        PersonalInformationViewModel: PersonalInformationViewModel,
    });

})(jQuery);